import React from 'react';
import { StarIcon } from 'lucide-react';
export function StarRating({
  rating,
  size = 'sm'
}: {
  rating: number;
  size?: 'sm' | 'md';
}) {
  const cls = size === 'md' ? 'h-4 w-4' : 'h-3.5 w-3.5';
  return <span className="flex" role="img" aria-label={`Beoordeeld met ${rating.toLocaleString('nl-NL')} van 5`} data-id="element-508" data-mp="3dmn403x5ww2m">
      {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className={`${cls} ${i < Math.round(rating) ? 'fill-amber-400 text-amber-400' : 'fill-line text-line'}`} aria-hidden="true" data-id="element-509" data-mp="3ijwt1ign35px" />)}
    </span>;
}